module.exports = __webpack_public_path__ + "media/src/assets/images/about_solution-pic3-966014a8a3d1596df57a26beabf8e9b1.png";